import { Button, Grid, MenuItem } from '@mui/material';

import { DesktopMenu, MenuItemType } from '../DesktopMenu/DesktopMenu';

import { TrackingEvents } from 'lib/tracking/events';
import { track } from 'lib/tracking/helper';

import menuData from './menuData.json';

const clientAreaUrl = process.env.WEBSITE_CLIENTAREA_URL || '';

/**
 * Desktop navigation
 */
export const Navigation = () => {
  return (
    <Grid container>
      <Grid item mb="0.4rem" display={{ xs: 'none', md: 'block' }} sm={10}>
        <DesktopMenu menuItems={menuData as MenuItemType[]} />
      </Grid>

      <Grid item mb="0.4rem" sm={2} display={{ xs: 'none', md: 'block' }}>
        <MenuItem
          onClick={() => {
            track(TrackingEvents.LOGIN_LINK_ONINTERACT);
          }}
          sx={{
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'center',
            height: '100%',
            letterSpacing: 0,
            p: '0 0.4rem',
            m: 0,

            '&.MuiMenuItem-root': {
              backgroundColor: 'transparent',
            },
          }}
        >
          <Button
            variant="text"
            href={clientAreaUrl}
            sx={{
              p: 0,
              m: 0,
              fontSize: '1rem',
              letterSpacing: 0,
              fontWeight: 400,
            }}
          >
            Kundenbereich
          </Button>
        </MenuItem>
      </Grid>
    </Grid>
  );
};
